import React from 'react';
import { Box, LinearProgress, Tooltip } from '@mui/material';

interface BudgetProgressBarMiniProps {
  budget_gg_uu: number;
  budget_pianificato_gg_uu: number;
  budget_disponibile_gg_uu: number;
}

const BudgetProgressBarMini: React.FC<BudgetProgressBarMiniProps> = ({
  budget_gg_uu,
  budget_pianificato_gg_uu,
  budget_disponibile_gg_uu
}) => {
  // Calcola percentuale utilizzata
  // Note: budget_pianificato_gg_uu include sia previsionali che consolidati
  const percentualeUtilizzata = (budget_pianificato_gg_uu / budget_gg_uu) * 100;

  // Determina il colore in base alla disponibilità
  let barColor: 'success' | 'warning' | 'error' = 'success';
  const percentualeDisponibile = (budget_disponibile_gg_uu / budget_gg_uu) * 100;

  if (percentualeDisponibile < 0) {
    barColor = 'error'; // Rosso se sforato
  } else if (percentualeDisponibile <= 20) {
    barColor = 'warning'; // Giallo se <= 20%
  }

  // Testo tooltip
  const tooltipText = `Budget: ${budget_gg_uu.toFixed(1)} gg | Pianificato: ${budget_pianificato_gg_uu.toFixed(1)} gg (${percentualeUtilizzata.toFixed(0)}%) | Disponibile: ${budget_disponibile_gg_uu.toFixed(1)} gg`;

  return (
    <Tooltip title={tooltipText} arrow placement="top">
      <Box sx={{ width: '100%', display: 'flex', alignItems: 'center' }}>
        <LinearProgress
          variant="determinate"
          value={Math.min(percentualeUtilizzata, 100)}
          color={barColor}
          sx={{
            height: 8,
            borderRadius: 4,
            width: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.08)',
            '& .MuiLinearProgress-bar': {
              borderRadius: 4,
            }
          }}
        />
      </Box>
    </Tooltip>
  );
};

export default BudgetProgressBarMini;
